<form [formGroup]="primaryFormGroup" class="grid grid-cols-3 gap-2">
    <div class="my-2 col-span-3">
        <mat-label>Primary Control Line (PCL)</mat-label>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>CL Tested</mat-label>
            <mat-select matNativeControl formControlName="valveTest">
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="UTT">UTT</mat-option>
                <mat-option value="NA">NA</mat-option>
            </mat-select>

            <!-- <input
                matInput
                class="input"
                formControlName="valveTest"
                [matAutocomplete]="valveTestedPrimary"
            />
            <mat-autocomplete
                autoActiveFirstOption
                #valveTestedPrimary="matAutocomplete"
            >
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="UTT">UTT</mat-option>
                <mat-option value="NA">NA</mat-option>
            </mat-autocomplete> -->
        </mat-form-field>
    </div>
    <div class="my-2 col-span-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Remarks <span class="text-sm text-gray-700">(if UTT/NA)</span></mat-label>
            <input matInput class="input" formControlName="remarks" />
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>CL Applied Pressure</mat-label>
            <input matInput class="input" formControlName="clTestedPressure" type="number" />
            <span matTextSuffix>psi</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>CL Initial Pressure ( 0 min )</mat-label>
            <input matInput class="input" formControlName="clInitialPressure" type="number" />
            <span matTextSuffix>psi</span>
        </mat-form-field>
    </div>

    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>CL Final Pressure ( 15 min )</mat-label>
            <input matInput class="input" formControlName="clPressureAfterTest" type="number" />
            <span matTextSuffix>psi</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Hydraulic Return</mat-label>
            <input matInput class="input" formControlName="hydraulicReturn" type="number" />
            <span matTextSuffix>ml</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Blowing gas</mat-label>
            <mat-select matNativeControl formControlName="blowingGas">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
            </mat-select>

            <!-- <input matInput class="input" formControlName="blowingGas" /> -->
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Period of Testing</mat-label>
            <input matInput class="input" formControlName="periodOfTesting" type="number" />
            <span matTextSuffix>min</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>C/Line Test Result</mat-label>
            <mat-select matNativeControl formControlName="clTestedResult">
                <mat-select-trigger class="rounded">
                    <span class="p-2 font-semibold" [ngClass]="{
                    'bg-good': primaryFormGroup.get('clTestedResult')?.value === 'Passed',
                    'bg-failed': primaryFormGroup.get('clTestedResult')?.value === 'Failed'
                  }">
                        {{ primaryFormGroup.get('clTestedResult')?.value || 'Select Result' }}
                    </span>
                </mat-select-trigger>

                <ng-container *ngIf="['Yes', 'UTT'].includes(primaryFormGroup.get('valveTest')?.value)">
                    <mat-option value="Passed">
                        <div class="bg-good p-2 rounded text-center text-black w-20">Passed</div>
                    </mat-option>
                    <mat-option value="Failed">
                        <div class="bg-failed p-2 rounded text-center text-black w-20">Failed</div>
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="primaryFormGroup.get('valveTest')?.value == 'UTT'">
                    <mat-option value="UTT">
                        <div class="p-2 rounded text-center text-black w-20"> UTT </div>
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="primaryFormGroup.get('valveTest')?.value == 'NA'">
                    <mat-option value="NA"> NA </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>
</form>
<hr />
<form [formGroup]="secondaryFormGroup" class="grid grid-cols-3 gap-2">
    <div class="my-2 col-span-3">
        <mat-label>Secondary Control Line (SCL)</mat-label>
    </div>
    <div class="my-2 col-start-1">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>CL Tested</mat-label>
            <mat-select matNativeControl formControlName="valveTest">
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="UTT">UTT</mat-option>
                <mat-option value="NA">NA</mat-option>
            </mat-select>

            <!-- <input
                matInput
                class="input"
                formControlName="valveTest"
                [matAutocomplete]="valveTestedSecondary"
            />
            <mat-autocomplete
                autoActiveFirstOption
                #valveTestedSecondary="matAutocomplete"
            >
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="UTT">UTT</mat-option>
                <mat-option value="NA">NA</mat-option>
            </mat-autocomplete> -->
        </mat-form-field>
    </div>
    <div class="my-2 col-span-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Remarks <span class="text-sm text-gray-700">(if UTT/NA)</span></mat-label>
            <input matInput class="input" formControlName="remarks" />
        </mat-form-field>
    </div>

    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>SVLN Installed</mat-label>
            <mat-select matNativeControl formControlName="svlnInstalled">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>CL Applied Pressure</mat-label>
            <input matInput class="input" formControlName="clTestedPressure" type="number" />
            <span matTextSuffix>psi</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>CL Initial Pressure ( 0 min )</mat-label>
            <input matInput class="input" formControlName="clInitialPressure" type="number" />
            <span matTextSuffix>psi</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>CL Final Pressure ( 15 min )</mat-label>
            <input matInput class="input" formControlName="clPressureAfterTest" type="number" />
            <span matTextSuffix>psi</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Hydraulic Return</mat-label>
            <input matInput class="input" formControlName="hydraulicReturn" type="number" />
            <span matTextSuffix>ml</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Blowing gas</mat-label>
            <mat-select matNativeControl formControlName="blowingGas">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
            </mat-select>

            <!-- <input matInput class="input" formControlName="blowingGas" /> -->
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Period of Testing</mat-label>
            <input matInput class="input" formControlName="periodOfTesting" type="number" />
            <span matTextSuffix>min</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>C/Line Test Result</mat-label>
            <mat-select matNativeControl formControlName="clTestedResult">
                <mat-select-trigger class="rounded">
                    <span class="p-2 font-semibold" [ngClass]="{
                    'bg-good': secondaryFormGroup.get('clTestedResult')?.value === 'Passed',
                    'bg-failed': secondaryFormGroup.get('clTestedResult')?.value === 'Failed'
                  }">
                        {{ secondaryFormGroup.get('clTestedResult')?.value || 'Select Result' }}
                    </span>
                </mat-select-trigger>

                <ng-container *ngIf="['Yes', 'UTT'].includes(primaryFormGroup.get('valveTest')?.value)">
                    <mat-option value="Passed">
                        <div class="bg-good p-2 rounded text-center text-black w-20">Passed</div>
                    </mat-option>
                    <mat-option value="Failed">
                        <div class="bg-failed p-2 rounded text-center text-black w-20">Failed</div>
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="primaryFormGroup.get('valveTest')?.value == 'UTT'">
                    <mat-option value="UTT">
                        <div class="p-2 rounded text-center text-black w-20"> UTT </div>
                    </mat-option>
                </ng-container>

                <ng-container *ngIf="primaryFormGroup.get('valveTest')?.value == 'NA'">
                    <mat-option value="NA"> NA </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>
</form>